import React from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

import { setRole } from 'reducers/auth';

import LoginService from 'services/LoginService';
import LoginStyleService from 'services/login/LoginStyleService';

import ChalkboardLayout from './ChalkboardLayout'
import LeftLayout from './LeftLayout'

const ACTIVE = true;

class Login extends React.Component {
  constructor() {
    super();

    this.state = {
      username: '',
      password: '',
      quickLogins: [],
      background: null,
      layout: null
    };
  }
  async componentDidMount() {
    const layout = await LoginStyleService.getLayout();
    const background = await LoginStyleService.getBackgroundPath();
    const clientLogo = await LoginStyleService.getLogoPath();

    try {
      this.setState({
        quickLogins: await LoginService.getQuickLogins(ACTIVE),
        layout: layout,
        background: background,
        clientLogo: clientLogo
      });
    } catch (e) {
      console.error(e.message, e);
    }
  }
  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value, error: '' });
  };
  handleQuickLogin = (UserID) => async (e) => {
    try {
      this.handleRedirect(await LoginService.quickLogin(UserID));
    } catch (e) {
      console.error(e.message, e);
    }
  };
  login = async () => {
    try {
      if (this.state.username && this.state.password) {
        this.handleRedirect(await LoginService.login(this.state.username, this.state.password));
      } else {
        this.setState({ error: 'Please enter both a username and password' });
      }
    } catch (e) {
      console.error('No data returned:', e.message);
    }
  };
  handleRedirect = (role) => {
    let url = LoginService.getLoginPath(role)
    if (!!url) {
      this.props.setRole(role);
      return this.props.push(url);
    } else {
      this.setState({ error: 'Incorrect username and/or password', password: '' });
      return;
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.login();
  };

  renderChalkboardLayout() {
    return (
      <ChalkboardLayout
        username = {this.state.username}
        password = {this.state.password}
        quickLogins = {this.state.quickLogins}
        error = {this.state.error}
        onQuickLogin = {this.handleQuickLogin}
        onSubmit = {this.handleSubmit}
        onChange = {this.handleChange}
        background = {this.state.background}
      />
    );
  }

  renderLeftLayout() {
    return (
      <LeftLayout
        username = {this.state.username}
        password = {this.state.password}
        quickLogins = {this.state.quickLogins}
        error = {this.state.error}
        onQuickLogin = {this.handleQuickLogin}
        onSubmit = {this.handleSubmit}
        onChange = {this.handleChange}
        background = {this.state.background}
        clientLogo = {this.state.clientLogo}
      />
    );
  }

  render() {
    let token = sessionStorage.getItem('token');

    if (token && token !== 'undefined') {
      let obj = JSON.parse(atob(token.split('.')[1]));
      let now = Date.now();
      let expires = obj.exp * 1000;
      if (now > expires) {
        sessionStorage.clear();
      } else {
        setTimeout(this.handleRedirect, 0, obj.rl);
      }
    }

    const layout = this.state.layout;
    if (layout === "chalkboard") {
      return this.renderChalkboardLayout();
    } else if (layout === "left") {
      return this.renderLeftLayout();
    } else {
      return (<span>Loading...</span>);
    }
  }
}

export default connect(null, dispatch => ({
  push: url => dispatch(push(url)),
  setRole: role => dispatch(setRole(role))
}))(Login);



// WEBPACK FOOTER //
// ./src/views/LoginView/LoginView.js